class SiteFooter extends HTMLElement {
  constructor() {
    super();

    this.mobileAccordion = this.querySelectorAll('[data-mobile-accordion]');
  }

  connectedCallback() {
    this.mobileAccordion?.forEach(accordion => {
      let title = accordion.querySelector('[data-accordion-title]');
      let content = accordion.querySelector('[data-accordion-content]');
      content.style.display = 'none';
      title.addEventListener('click', (e) => {
        e.preventDefault();
        accordion.classList.toggle('open');
        Utility?.slideToggle(content, 300);
      });
    });
  }

}
customElements.define('site-footer', SiteFooter);